import { Component, OnInit, Injectable, ElementRef, ViewChild, Inject, forwardRef } from '@angular/core';

import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Keepalive} from '@ng-idle/keepalive';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { CallBackEndService } from '../call-back-end.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
declare var jQuery:any;


@Component({
  selector: 'app-session-timer',
  templateUrl: './session-timer.component.html',
  styleUrls: ['./session-timer.component.css'],
  providers:[CallBackEndService],
})
@Injectable()
export class SessionTimerComponent implements OnInit {


   idleState = 'Not started.';
  timedOut = false;
lastPing?: Date = null;
countdwn:number;
showModal: boolean;
   myModal:any;
  constructor( private idle: Idle,
private keepalive: Keepalive,
@Inject(CallBackEndService)private webService: CallBackEndService,
public router: Router,private toastr: ToastrService) {
	  	//this.startSessionTimer();	
	  		 this.idle.setIdle(60);
			    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
     this.idle.setTimeout(10);
  console.log("1--"+this.idleState)
    // sets the ping interval to 15 seconds
	this.keepalive.interval(10);
	  this. idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
	  this.timedOut = true;
	});
	
	this. idle.onIdleStart.subscribe(() => {this.idleState = 'You\'ve gone idle!';console.log("3--"+this.idleState)});
	
   this. idle.onTimeoutWarning.subscribe((countdown) => {
     this.idleState = 'You will time out in ' + countdown + ' seconds!';
	 this.countdwn=countdown;
	 console.log('You will time out in ' +this.countdwn + ' seconds!');
	// if(countdown<=5) { 
	//   this.showModal=true;
	// //	(document.querySelector('.myModal') as HTMLElement).style.display = 'block';
	// 	var ans=confirm("You will be logged out in"+countdown+"sec...Keep logged in?");
	// 	if(ans==true)
	// 	{
    //        this.startSessionTimer();
	// 	}else
	// 	{
	// 		this.logout();
	// 	}

  // }
  //make countdown=1 after wards--- by manish 
	if(countdown==1) { 
	//	(document.getElementById('myModal') as HTMLElement).style.display="block";
		 //modal.style.display = "block";
			  this.toastr.error("Login Again", 'Your Session Is Expired .',{'easeTime':0,'closeButton':true,'timeOut':10000});

		this.logout();
	}
     });
   this.keepalive.onPing.subscribe(() => this.lastPing = new Date());
   }

  ngOnInit() {
   
  }
startSessionTimer() {
    this.idle.watch();
    this.idleState = 'Started.';
	this.timedOut = false;
	console.log("SESS--"+this.idleState);
  }
  logout()
  {
	  console.log("call service 345345");
      const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    request.param1 =sessionStorage.getItem('token'); 
    request.param2 =sessionStorage.getItem('storedUserName');
    this.stopTimer();
    this.webService.getResponse(request, 'logout').subscribe((data: IbResponse) => {
      console.log('logout yuiyu'+data.status);
      
      if (data !== null && data.status === 'S200') {
        console.log('logout service');
       sessionStorage.removeItem('currentUser');
       sessionStorage.removeItem('isPasswordExpire');
         sessionStorage.removeItem('token');
         sessionStorage.removeItem('custNo');
         sessionStorage.removeItem('accounts');
       sessionStorage.clear();
       
      this.router.navigate(['/login']);
          
        //this.showLoanAmount ='Hide';
      }


    });
  }

stopTimer()
{
	this.idle.stop();
   this.idleState = 'Timed out!';
	  this.timedOut = true;
	  console.log("Timed Out")
}
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/session-timer/session-timer.component.ts